// src/api/anomalyDetectionService.js

import api from "./api";

const API_URL = "/AnomalyDetection";

/* =========================
   NORMALIZE INPUT
========================= */
const normalizeInput = (data) => {
    const items = Array.isArray(data) ? data : [data];

    return items.map((item) => {
        if (item.features) {
            return {
                feature1: item.features[0],
                feature2: item.features[1],
                feature3: item.features[2],
                timestamp: item.timestamp ?? new Date().toISOString(),
            };
        }

        return {
            feature1: item.feature1,
            feature2: item.feature2,
            feature3: item.feature3,
            timestamp: item.timestamp ?? new Date().toISOString(),
        };
    });
};

/* =========================
   RUN ANOMALY DETECTION
========================= */
export const predictAnomalies = async (inputData) => {
    try {
        const normalized = normalizeInput(inputData);

        const res = await api.post(
            `${API_URL}/predict-anomalies`,
            normalized
        );

        return (
            res?.data?.data ||
            res?.data?.predictions ||
            res?.data
        );

    } catch (error) {
        console.error("Anomaly detection error:", error);
        throw error;
    }
};

export default {
    predictAnomalies,
};